import React from 'react';
import { FaUserCircle } from 'react-icons/fa';

/**
 * UserAvatar component to display farmer icon for farmers and user circle for admins.
 * 
 * @param {Object} props
 * @param {Object|string} props.user - User object or user role string
 * @param {number|string} props.size - Size of the avatar
 * @param {string} props.className - Additional CSS classes
 */
const UserAvatar = ({ user, size = 28, className = '' }) => {
  const role = typeof user === 'string' ? user : (user?.role || '');
  const isFarmer = role === 'FARMER';

  if (isFarmer) {
    return (
      <div 
        className={`rounded-full overflow-hidden bg-white flex-shrink-0 flex items-center justify-center border border-divider ${className}`}
        style={{ width: size, height: size }}
      >
        <img 
          src="/farmerIcon.png" 
          alt="Farmer" 
          className="w-full h-full object-cover" 
        />
      </div>
    );
  }

  return <FaUserCircle size={size} className={className || 'text-primary'} />;
};

export default UserAvatar;
